import { lazy, Suspense, useContext } from 'react'
import type { ComponentProps } from 'react'
import type TokenBannerEditorInner from '@/components/TokenBannerEditorInner'
import { WalletReadyContext } from '@/lib/walletContext'

/**
 * Client-only boundary for the creator token-banner editor.
 *
 * The inner editor uses wagmi `useWalletClient` so Save can open the connected
 * AppKit wallet sign modal. Loading it lazily keeps the Node prerender path
 * free of WalletConnect `require("ws")`.
 *
 * DO NOT convert this back into a static import.
 */
const TokenBannerEditorInnerLazy = lazy(() => import('@/components/TokenBannerEditorInner'))

type TokenBannerEditorProps = ComponentProps<typeof TokenBannerEditorInner>

function TokenBannerEditor(props: TokenBannerEditorProps) {
  const ready = useContext(WalletReadyContext)
  if (!ready)
    return null

  return (
    <Suspense fallback={null}>
      <TokenBannerEditorInnerLazy {...props} />
    </Suspense>
  )
}

export default TokenBannerEditor
